module.exports = __webpack_public_path__ + "static/media/corona-death.bc0b9bf7.jpg";